import lazyLoading from "./lazyLoading";
import { rolesObj } from "../roleDefinitions";

const WT_ADMIN = rolesObj.wtAdmin.serverValue;
const WT_ADMIN_SUPER = rolesObj.superWtAdmin.serverValue;

const adminPanelMeta = {
  viewTitle: "Super Admin",
  auth: {
    roles: [WT_ADMIN, WT_ADMIN_SUPER],
    forbiddenRedirect: { name: "403" }
  }
};

export const adminSuperRoutes = {
  path: "/adminsuper",
  redirect: "/adminsuper/member-center",
  name: "AdminSuper",
  component: lazyLoading("AdminSuper"),
  meta: {
    ...adminPanelMeta,
    menuIcon: "logo"
  },
  children: [
    {
      path: "program/create",
      name: "CreateBeWellProgram",
      meta: {
        ...adminPanelMeta,
        linkTitle: "CREATE PROGRAM"
      },
      component: lazyLoading("SetupPage")
    },
    {
      path: "member-center",
      name: "AdminSuperMemberCenter",
      meta: {
        ...adminPanelMeta,
        linkTitle: "MEMBERS"
      },
      component: lazyLoading("AdminSuperMemberCenter")
    },
    {
      path: "challenge-center",
      name: "AdminSuperChallengeCenter",
      meta: {
        ...adminPanelMeta,
        linkTitle: "CHALLENGES"
      },
      redirect: { name: "AdminSuperChallengeCenterSettings" },
      component: lazyLoading("AdminSuperChallengeCenter"),
      children: [
        {
          path: "settings",
          name: "AdminSuperChallengeCenterSettings",
          meta: {
            viewTitle: adminPanelMeta.viewTitle
          },
          component: lazyLoading("AdminSuperChallengeCenterSettings")
        },
        {
          path: "builder/:mode?",
          name: "AdminSuperChallengeCenterBuilder",
          props: true,
          meta: {
            viewTitle: adminPanelMeta.viewTitle
          },
          component: lazyLoading("ChallengeCenterBuilder")
        }
      ]
    },
    {
      path: "maps-center",
      name: "AdminSuperMapsCenter",
      meta: {
        ...adminPanelMeta,
        linkTitle: "MAPS"
      },
      redirect: { name: "AdminSuperMapsCenterSettings" },
      component: lazyLoading("AdminSuperMapsCenter"),
      children: [
        {
          path: "settings",
          name: "AdminSuperMapsCenterSettings",
          meta: {
            viewTitle: adminPanelMeta.viewTitle
          },
          component: lazyLoading("AdminSuperMapsCenterSettings")
        },
        {
          path: "builder",
          name: "AdminSuperMapsBuilder",
          meta: {
            viewTitle: adminPanelMeta.viewTitle
          },
          component: lazyLoading("AdminSuperMapsBuilder")
        }
      ]
    },
    {
      path: "stats-reporting",
      name: "AdminSuperStatsReporting",
      meta: {
        ...adminPanelMeta,
        linkTitle: "STATS/REPORTING"
      },
      component: lazyLoading("AdminSuperStatsReporting")
    },
    {
      path: "reporting",
      name: "AdminSuperReporting",
      meta: {
        ...adminPanelMeta,
        linkTitle: "REPORTING"
      },
      component: lazyLoading("AdminSuperReporting")
    },
    {
      path: "mobile-app",
      name: "AdminSuperMobileSupport",
      meta: {
        ...adminPanelMeta,
        linkTitle: "MOBILE APP"
      },
      component: lazyLoading("AdminSuperMobileSupport")
    },
    {
      path: "resellers",
      name: "AdminSuperResellers",
      meta: {
        ...adminPanelMeta,
        linkTitle: "RESELLERS"
      },
      component: lazyLoading("AdminSuperResellers")
    }
  ]
};

export default adminSuperRoutes;
